<div class="page-layout">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Breadcrumb -->
    <nav class="breadcrumb">
      <a href="#" class="breadcrumb-item">
        <svg viewBox="0 0 24 24" class="breadcrumb-icon">
          <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      </a>
      <span class="breadcrumb-separator">›</span>
      <a href="#" class="breadcrumb-item">Settings</a>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-item active">Managers</span>
    </nav>

    <!-- Page Header -->
    <header class="page-header">
      <h1 class="page-title">Managers</h1>
      <button class="btn btn-primary" (click)="openAddModal()">
        <svg viewBox="0 0 24 24" class="btn-icon">
          <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
        Add manager
      </button>
    </header>

    <!-- Content Card -->
    <div class="content-card">
      <!-- Table Header -->
      <div class="table-header">
        <div class="table-title-section">
          <h2 class="table-title">Managers list</h2>
          <span class="badge badge-blue">{{managers.length}}</span>
        </div>
        <div class="search-box">
          <svg viewBox="0 0 24 24" class="search-icon">
            <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Search"
            class="search-input"
            [(ngModel)]="searchQuery"
            (input)="onSearch()"
          />
        </div>
      </div>

      <!-- Table (desktop) -->
      <div class="table-container hide-mobile">
        <table class="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Branch Access</th>
              <th>Sport Access</th>
              <th>Joined</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="7" style="text-align: center; padding: 2rem;">
                Loading managers...
              </td>
            </tr>
            <tr *ngIf="!isLoading && paginatedManagers.length === 0">
              <td colspan="7" style="text-align: center; padding: 2rem;">
                No managers found.
              </td>
            </tr>
            <tr *ngFor="let manager of paginatedManagers" class="table-row animate-fade-in">
              <td>
                <div class="trainer-info">
                  <div class="trainer-avatar">
                    <img [src]="getAvatar(manager.name)" [alt]="manager.name"/>
                  </div>
                  <div class="trainer-details">
                    <div class="trainer-name">{{manager.name}}</div>
                    <div class="trainer-email">{{manager.email || 'No email'}}</div>
                  </div>
                </div>
              </td>
              <td>
                <span class="phone-text">{{manager.phoneNumber}}</span>
              </td>
              <td>
                <span class="specialty-text">{{manager.email || 'N/A'}}</span>
              </td>
              <td>
                <span class="specialty-text">{{getBranchNames(manager)}}</span>
              </td>
              <td>
                <span class="specialty-text">{{getSportNames(manager)}}</span>
              </td>
              <td>
                <span class="salary-text">{{manager.createdAt | date: 'MMM d, y'}}</span>
              </td>
              <td>
                <div class="action-buttons">
                  <button class="action-btn" title="Edit" (click)="openEditModal(manager)">
                    <svg viewBox="0 0 24 24">
                      <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Cards -->
      <div class="mobile-cards show-mobile">
        <div *ngIf="isLoading" style="text-align: center; padding: 2rem;">
          Loading managers...
        </div>
        <div *ngIf="!isLoading && paginatedManagers.length === 0" style="text-align: center; padding: 2rem;">
          No managers found.
        </div>
        <div class="mobile-card animate-fade-in" *ngFor="let manager of paginatedManagers">
          <div class="mobile-card-header">
            <div class="trainer-info">
              <div class="trainer-avatar">
                <img [src]="getAvatar(manager.name)" [alt]="manager.name"/>
              </div>
              <div class="trainer-details">
                <div class="trainer-name">{{manager.name}}</div>
                <div class="trainer-email">{{manager.email || 'No email'}}</div>
              </div>
            </div>
            <div class="action-buttons">
              <button class="action-btn" title="Edit" (click)="openEditModal(manager)">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-row">
              <span class="mobile-card-label">Phone</span>
              <span class="phone-text">{{manager.phoneNumber}}</span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">Branch Access</span>
              <span class="specialty-text">{{getBranchNames(manager)}}</span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">Sport Access</span>
              <span class="specialty-text">{{getSportNames(manager)}}</span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">Joined</span>
              <span class="salary-text">{{manager.createdAt | date: 'MMM d, y'}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination">
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
          </svg>
          Previous
        </button>
        <div class="pagination-numbers">
          <button
            *ngFor="let page of visiblePages"
            class="page-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{page}}
          </button>
        </div>
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
          Next
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </button>
      </div>
    </div>
  </main>
</div>

<!-- Add / Edit Manager Modal -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{modalMode === 'add' ? 'Add Manager' : 'Edit Manager'}}</h2>
      <button class="modal-close" (click)="closeModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label class="form-label">Name *</label>
        <input type="text" class="form-input" placeholder="Enter manager name" [(ngModel)]="form.name"/>
      </div>

      <ng-container *ngIf="modalMode === 'add'">
        <div class="form-group">
          <label class="form-label">Phone Number *</label>
          <input type="tel" class="form-input" placeholder="e.g. 05xxxxxxxx" [(ngModel)]="form.phoneNumber"/>
        </div>
        <div class="form-group">
          <label class="form-label">Password *</label>
          <input type="password" class="form-input" placeholder="Enter password" [(ngModel)]="form.password"/>
        </div>
      </ng-container>

      <div class="form-group">
        <label class="form-label">Email</label>
        <input type="email" class="form-input" placeholder="Enter email (optional)" [(ngModel)]="form.email"/>
      </div>

      <div class="form-group">
        <label class="form-label">Branch Access</label>
        <div class="checkbox-grid">
          <label class="checkbox-item" *ngFor="let branch of branches">
            <input
              type="checkbox"
              [checked]="isBranchSelected(branch.id)"
              (change)="toggleBranch(branch.id)"
            />
            <span>{{branch.name}}</span>
          </label>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">Sport Access</label>
        <div class="checkbox-grid">
          <label class="checkbox-item" *ngFor="let sport of sports">
            <input
              type="checkbox"
              [checked]="isSportSelected(sport.id)"
              (change)="toggleSport(sport.id)"
            />
            <span>{{sport.name}}</span>
          </label>
        </div>
      </div>

      <!-- Permissions Grid -->
      <div class="form-group" *ngIf="permissions.length > 0">
        <label class="form-label">Permissions</label>
        <div class="permissions-grid">
          <div class="permissions-row permissions-header">
            <span class="perm-label">Branch / Sport</span>
            <span class="perm-check">View Plans</span>
            <span class="perm-check">Edit Plans</span>
            <span class="perm-check">View Subs</span>
            <span class="perm-check">Confirm Pay</span>
            <span class="perm-check">Attendance</span>
          </div>
          <div class="permissions-row" *ngFor="let perm of permissions">
            <span class="perm-label">{{perm.branchName}} / {{perm.sportName}}</span>
            <label class="perm-check">
              <input type="checkbox" [(ngModel)]="perm.canViewPlans"/>
            </label>
            <label class="perm-check">
              <input type="checkbox" [(ngModel)]="perm.canEditPlans"/>
            </label>
            <label class="perm-check">
              <input type="checkbox" [(ngModel)]="perm.canViewSubscriptions"/>
            </label>
            <label class="perm-check">
              <input type="checkbox" [(ngModel)]="perm.canConfirmPayment"/>
            </label>
            <label class="perm-check">
              <input type="checkbox" [(ngModel)]="perm.canAddAttendance"/>
            </label>
          </div>
        </div>
      </div>

      <div class="form-error" *ngIf="modalError">{{modalError}}</div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeModal()" [disabled]="isSaving">Cancel</button>
      <button class="btn btn-primary" (click)="submitManager()" [disabled]="isSaving">
        {{isSaving ? (modalMode === 'add' ? 'Creating...' : 'Saving...') : (modalMode === 'add' ? 'Create Manager' : 'Save Changes')}}
      </button>
    </div>
  </div>
</div>
